import { Reveal, Eyebrow } from "./Reveal";
import { Star } from "lucide-react";

const testimonials = [
  {
    quote:
      "We stopped losing Saturday-morning no-cool calls. The first month paid for the whole year.",
    name: "Mike R.",
    role: "Owner, HVAC company · Dallas, TX",
    initials: "MR",
    trade: "HVAC",
  },
  {
    quote:
      "Backfill caught 31 after-hours calls in our first 60 days. Nineteen of them turned into booked jobs.",
    name: "Dana S.",
    role: "Co-owner, plumbing company · Columbus, OH",
    initials: "DS",
    trade: "Plumbing",
  },
  {
    quote:
      "Storm week used to mean 40 missed calls. Now every single one gets a text in under ten seconds.",
    name: "Chris T.",
    role: "GM, roofing company · Tampa, FL",
    initials: "CT",
    trade: "Roofing",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="border-t border-white/[0.06] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="text-center">
          <Eyebrow>Trusted in the Field</Eyebrow>
          <h2 className="mx-auto mt-4 max-w-2xl font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
            Contractors who stopped leaking revenue
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {testimonials.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.08} className="h-full">
              <figure
                data-testid={`testimonial-${i}`}
                className="flex h-full flex-col rounded-xl border border-white/[0.08] bg-[#12161F] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#F25F22]/40"
              >
                <div className="flex gap-1">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-[#F25F22] text-[#F25F22]" />
                  ))}
                </div>
                <blockquote className="mt-5 flex-1 text-base leading-relaxed text-slate-300">
                  &ldquo;{t.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3 border-t border-white/[0.06] pt-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#F25F22]/30 bg-[#F25F22]/10 font-display text-xs font-bold text-[#F25F22]">
                    {t.initials}
                  </span>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-slate-100">{t.name}</p>
                    <p className="truncate text-xs text-slate-500">{t.role}</p>
                  </div>
                  <span className="ml-auto shrink-0 rounded-full border border-white/[0.1] px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider text-slate-400">
                    {t.trade}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
